import { createFileRoute } from '@tanstack/react-router';
import { ReleaseNoteEditionView } from '@/features/release-notes/ReleaseNoteEditionView';

function EditionRoute() {
  const { key } = Route.useParams();
  const { asUser } = Route.useSearch();
  return <ReleaseNoteEditionView editionKey={key} asUser={asUser} />;
}

export const Route = createFileRoute('/release-notes/$key')({
  validateSearch: (raw: Record<string, unknown>): { asUser?: string } => ({
    asUser: typeof raw.asUser === 'string' && raw.asUser ? raw.asUser : undefined
  }),
  component: EditionRoute
});
